import React, { useState } from 'react';
import classNames from 'classnames';

import './Accordion.scss';

export const Accordion = ({title, children, arrowPosition = 'right', open = false, borderBottom = true, borderTop = false, modification = ''}) => {
  const [opened, setOpened] = useState(open);

  return (
    <div styleName={classNames('section-accordion', {
      'section-accordion--border-top': borderTop,
      'section-accordion--border-bottom': borderBottom,
      [`section-accordion--${modification}`]: !!modification,
      opened
    })}>
      <div styleName={classNames('section-accordion__header', {
        'section-accordion__header--right': arrowPosition === 'right',
        'section-accordion__header--left': arrowPosition === 'left'
      })} onClick={() => setOpened(!opened)}>
        { typeof title !== 'string' && <div styleName="section-accordion__title">{title}</div> }
        { typeof title === 'string' && <div styleName="section-accordion__title section-accordion__title--font">{title}</div> }
        <span styleName="section-accordion__arrow" />
      </div>
      <div styleName="section-accordion__content">
        {children}
      </div>
    </div>
 );
};
